"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideOrder = exports.SideBySideAlignment = exports.SideBySideWidth = exports.AllowedPercentageValues = exports.createSideBySideDummy = exports.blankSlateColumn = exports.sideBySide = void 0;
var Text_1 = require("./Text");
var BasicBlocks_1 = require("./BasicBlocks");
var SideBySide_1 = require("ContentTokens/Models/SideBySide");
Object.defineProperty(exports, "AllowedPercentageValues", { enumerable: true, get: function () { return SideBySide_1.AllowedPercentageValues; } });
Object.defineProperty(exports, "SideBySideAlignment", { enumerable: true, get: function () { return SideBySide_1.SideBySideAlignment; } });
Object.defineProperty(exports, "SideBySideOrder", { enumerable: true, get: function () { return SideBySide_1.SideBySideOrder; } });
Object.defineProperty(exports, "SideBySideWidth", { enumerable: true, get: function () { return SideBySide_1.SideBySideWidth; } });
var Common_1 = require("ContentTokens/Models/Common");
exports.sideBySide = {
    createToken: function (column1, column2, options) {
        options = options || {};
        var placeholderIndex = options.placeholderIndex;
        var percent = options.percent || SideBySide_1.SideBySideColumnSize.OneHalf;
        var width = options.width || SideBySide_1.SideBySideWidth.Wide;
        var alignment = options.alignment || SideBySide_1.SideBySideAlignment.Normal;
        return {
            type: "block",
            subType: "sideBySide",
            column1: column1,
            column2: column2,
            percent: percent,
            width: width,
            alignment: alignment,
            placeholderIndex: placeholderIndex,
        };
    },
    createSlateJson: function () {
        return {
            isVoid: false,
            type: Common_1.BlockType.SideBySide,
            data: {
                width: SideBySide_1.SideBySideWidth.Wide,
                alignment: SideBySide_1.SideBySideAlignment.Normal,
                percent: SideBySide_1.SideBySideColumnSize.OneHalf,
                placeholderIndex: SideBySide_1.SideBySidePlaceholderIndex.Column2,
            },
            children: [
                {
                    isVoid: true,
                    type: Common_1.BlockType.SideBySideDummy,
                    children: [Text_1.text.createSlateJson("")],
                },
                (0, exports.blankSlateColumn)(),
                (0, exports.blankSlateColumn)(),
            ],
        };
    },
};
var blankSlateColumn = function () {
    return {
        isVoid: false,
        type: Common_1.BlockType.SideBySideColumn,
        children: [BasicBlocks_1.paragraph.createSlateJson([Text_1.text.createSlateJson("")])],
    };
};
exports.blankSlateColumn = blankSlateColumn;
var createSideBySideDummy = function () {
    return {
        isVoid: true,
        type: Common_1.BlockType.SideBySideDummy,
        children: [Text_1.text.createSlateJson("")],
    };
};
exports.createSideBySideDummy = createSideBySideDummy;
